/**
 * Index.js - Home page entry point
 */

// Quasar CSS imports (must be at top)
import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'

import { createApp } from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Loading from 'quasar/src/plugins/loading/Loading.js';;
import { createPinia } from 'pinia';

// Import your page's Vue component
// Update this import to match your actual component file
import PageComponent from './Index.vue';

// Import shared utilities
import api from '@services/api.js';
import EventHub from '@util/EventHub.js';
import esignBrand from '@theme/esignBrand.js';

// Create Vue application
const app = createApp(PageComponent);

// Install Pinia for state management
const pinia = createPinia();
app.use(pinia);

// Install Quasar with plugins
app.use(Quasar, {
    plugins: {
        Notify,
        Dialog,
        Loading
    },
    config: {
        brand: esignBrand,
        notify: {
            position: 'top-right',
            timeout: 3000
        },
        loading: {
            delay: 400
        }
    }
});

// Make api and EventHub globally available
app.config.globalProperties.$api = api;
app.config.globalProperties.$eventHub = EventHub;

// Provide for composition API usage
app.provide('api', api);
app.provide('eventHub', EventHub);

// Mount the application
app.mount('#q-app');

// Export for debugging
window._esignApp = app;
